import { useFormContext } from 'react-hook-form';

import type { FunctionComponent } from 'react';
import type { TypeInputProps } from './types';

/**
 * Input
 */
export const Input: FunctionComponent<TypeInputProps> = ({
  className = '',
  placeholder,
  type,
  name,
  requiredMessage,
  label,
  onBlur,
}: TypeInputProps) => {
  const {
    register,
    formState: { errors },
    trigger,
    setValue,
    setError,
    clearErrors,
  } = useFormContext();

  const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={name}
        className={`text-other--label-form uppercase ${
          errors[name] && 'text-[#ff0000]'
        }`}
      >
        {label}
        {requiredMessage && ' *'}
      </label>
      <input
        id={name}
        placeholder={placeholder}
        type={type}
        {...register(name, { required: requiredMessage })}
        className={`text-body  text-body--primary border-b bg-transparent pb-2 font-light outline-none ${
          errors[name]
            ? 'border-[#ff0000] text-[#ff0000] placeholder-[#ff0000]'
            : 'border-primary-400 text-primary-400 placeholder-primary-400'
        }  ${className}`}
        onChange={async (e) => {
          setValue(name, e.target.value);
          await trigger(name);
        }}
        onBlur={async (e) => {
          if (type === 'email') {
            if (!emailPattern.test(e.target.value)) {
              setError(name, {
                type: 'pattern',
                message: 'Introduce un email válido',
              });
            } else {
              clearErrors(name);
            }
          }
          if (onBlur) onBlur(e);
        }}
      />

      <span
        className={`text-other--detail text-[#ff0000] ${
          errors[name] ? 'block' : 'hidden'
        }`}
      >
        {errors[name]?.message}
      </span>
    </div>
  );
};

Input.displayName = 'Input';
